/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_Color_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shadow Color" |
*
* @param {Styles_Shadow_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_color_aria_label = /** @type {((inputs?: Styles_Shadow_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur d'ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schattenfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет тени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color de sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阴影颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("影の色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छाया रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor da Sombra")
	return /** @type {LocalizedString} */ ("Shadow Color")
});